import './index.css';
import { customerLoginBgIcon, secureIcon, selfixLogoIcon, vestelLogoIcon, whiteVideoCameraIcon } from '../../assets';
import { CheckBox } from '../../components/CheckBox';
import { useContext, useEffect, useState } from 'react';
import { ModalAlertContext } from '../../contexts/ModalAlertContext';
import { useNavigate, useParams } from 'react-router';
import strings from '../../localization';
import CallStore from '../../stores/CallStore';

const CustomerLogin = () => {
  const [isChecked, setIsChecked] = useState(false);
  const { showTextModalAlert, closeTextModalAlert, showModalAlert, closeModalAlert } = useContext(ModalAlertContext);
  const [slug, setSlug] = useState("");
  const [pin, setPin] = useState("");
  const params = useParams();
  const navigate = useNavigate();
  const [privacy, setPrivacy] = useState(null);
  const [termsOfService, setTermsOfService] = useState(null);
  const [callConsent, setCallConsent] = useState(null);
  const [hasLegal, setHasLegal] = useState(false);

  const handleJoinVideoCall = () => {
    navigate(`/live/c/${slug}?pin=${pin}`);
  };

  const handleSeeModal = (_callConsent) => {

    if (_callConsent)
      showTextModalAlert(
        {
          title: null,
          message: null,
          html: _callConsent ? _callConsent.html : null,
          okText: strings.iApprove,
          cancelText: strings.iDoNotApprove,
          onOk: () => {
            setIsChecked(true);
            closeTextModalAlert();
          },
          onCancel: () => {
            showModalAlert({
              title: strings.error,
              message: strings.youMustApproveTheCallConsentToJoinTheCall,
              confirmText: strings.ok,
              type: "error",
              onConfirm: () => {
                closeModalAlert();
              },
              onCancel: null
            });
          }
        });

  };


  const getLegalForCustomer = (_slug) => {
    CallStore.getLegalForCustomer(_slug).then((response) => {
      if (response.success) {
        setPrivacy(response.data.find((item) => item.docType === 'privacy_policy'));
        setTermsOfService(response.data.find((item) => item.docType === 'terms_of_service'));
        const _callConsent = response.data.find((item) => item.docType === 'call_consent');
        setCallConsent(_callConsent);
        handleSeeModal(_callConsent);
        setHasLegal(true);
      } else {
        setHasLegal(false);
      }
    });
  }

  useEffect(() => {

    localStorage.removeItem('callToken');
    const slug = params.slug;
    const pin = params.pin;
    localStorage.setItem('slug', slug);
    localStorage.setItem('pin', pin);
    if (slug && pin) {
      setSlug(slug);
      setPin(pin);

      getLegalForCustomer(slug);

    } else {
      showModalAlert(
        {
          title: strings.error,
          message: strings.invalidUrlContactWithYourSupportTeam,
          confirmText: strings.ok,
          type: "error",
          onConfirm: () => { },
          onCancel: null
        });
    }
  }, []);

  var disabled = !isChecked;
  if (!hasLegal) {
    disabled = false;
  }

  return (
    <div className="customer-login">
      <img src={customerLoginBgIcon} alt="customer-login-bg" className="customer-login-bg" />
      <div className="customer-login-content">
        <div className="customer-login-content-texts">
          <img src={vestelLogoIcon} alt="vestel-logo" className="customer-login-content-texts-logo" />
          <h2 className="customer-login-content-texts-description">
            {strings.welcome} <br />
            {strings.joinSupportSession}
          </h2>
        </div>

        <div className="customer-login-content-form">
          <span className="customer-login-content-form-title">
            {strings.yourVideoCallWillBeginShortly}
            {' '}
            {strings.pleaseAcceptTheRelevantLegalNoticeAndStartTheCall}
          </span>
          {hasLegal && (
            <div className="customer-login-content-form-checkbox-container">
              <CheckBox value={isChecked} onChange={() => { setIsChecked(!isChecked) }} />
              <div className="customer-login-content-form-checkbox-container-label">

                {strings.iAgreeToThe}
                {' '}
                <i>{termsOfService && <a href={termsOfService.url} target="_blank" rel="noopener noreferrer">{strings.termsOfService}</a>}</i>
                {' '}
                &
                {' '}
                <i>{privacy && <a href={privacy.url} target="_blank" rel="noopener noreferrer">{strings.privacyPolicy}</a>}</i>
              </div>
            </div>
          )}

          <button className='button-cta-secondary' disabled={disabled} onClick={handleJoinVideoCall}>
            <img src={whiteVideoCameraIcon} alt="video-camera" />
            <span>{strings.joinVideoCall}</span>
          </button>

          <div className="customer-review-view-footer">
            <img src={selfixLogoIcon} alt="customer-review" className="customer-review-view-selfix-logo" />
            <div className="customer-review-view-secure-info">
              <img src={secureIcon} alt="customer-review" />
              <p>{strings.yourSessionIsSecureAndEncrypted}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default CustomerLogin;